/** Label sheet export — a PDF, read as a blob since it needs the auth header a plain link can't send. */

import { api } from '../api.js';
import type { ShopId, VariantId } from '../../types/api.js';

export type ExportLabelSheetBody = {
  readonly variantIds: VariantId[];
  readonly shopId?: ShopId | undefined;
  readonly onePerUnitInStock?: boolean | undefined;
  readonly copiesPerVariant?: number | undefined;
  readonly includePrice?: boolean | undefined;
};

export const labelsApi = api.injectEndpoints({
  endpoints: (build) => ({
    exportLabelSheet: build.mutation<Blob, ExportLabelSheetBody>({
      query: (body) => ({
        url: '/labels/sheet',
        method: 'POST',
        body,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
});

export const { useExportLabelSheetMutation } = labelsApi;
